import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { UrlResolverPipeStrategy } from './url-resolver-pipe-strategy.interface';
import { S3StorageService } from './s3-storage.service';

@Pipe({ name: 's3Url' })
export class S3UrlResolverPipe implements PipeTransform, UrlResolverPipeStrategy {
  constructor(private s3StorageService: S3StorageService) {}

  private static readonly s3HostPattern = /^https:\/\/[^/]+\.s3\.[^/]+\.amazonaws\.com\//;

  canHandle(url: string): boolean {
    return S3UrlResolverPipe.s3HostPattern.test(url);
  }

  transform(url: string): Observable<string> {
    return this.s3StorageService.resolve(url);
  }
}
